import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-search-icon',
  imports: [],
  templateUrl: './search-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './search-icon.component.scss',
})
export class SearchIconComponent {}
